<template>
  <div>
    <!-- INTESTAZIONE MOBILE -->
     <div class="block md:!hidden">

      <div class="text-white relative flex justify-end -mb-6 w-full ">
              <!-- Dark Mode Toggle -->
              <div
                 :title="darkMode ? 'Passa alla Light Mode' : 'Passa alla Dark Mode'"
                 @click="toggleDarkMode()"
                 class=" bg-csenBlue-900 dark:bg-csenBlue-800 text-csenBlue-100 inline-flex justify-center content-center px-auto cursor-pointer rounded-full hover:bg-csenOrange-500 dark:hover:bg-csenOrange-500 hover:text-white transition w-9 h-9"
                 >
                 <SunIcon v-if="darkMode" class="my-auto" />
                 <MoonIcon v-else class="my-auto" />
              </div>
      </div>


        <div class="flex flex-col items-center">
           <div class="primary--text text-center md:text-left font-sans flex flex-col md:flex-row md:gap-x-5 my-auto items-center">
              <div class="my-auto">
                 <img @click="redirectToTecnici()" class="max-w-[70px] rounded-full mx-auto md:mx-0" src="https://csencorsi.it/wp-content/uploads/2023/04/logo_150.png">
              </div>
              <div class="my-auto mt-4 mb-5 md:mt-0 text-center md:text-left">
                 <div class="font-semibold text-xl text-white">Albo Tecnici CSEN</div>
                 <div class="font-medium text-base text-csenBlue-200">Centro Nazionale di Formazione</div> 
                 <div  class="font-medium text-base text-csenBlue-200">(patentini / tesserini cartacei blu)</div>
              </div>
           </div>

        </div>
     </div>
     <!-- FINE INTESTAZIONE MOBILE -->
     <!-- INTESTAZIONE DESKTOP -->
     <div class="hidden md:!flex">
        <div class="primary--text text-left font-sans flex gap-x-5 my-auto">
           <div class="my-auto"><img @click="redirectToTecnici()" class="max-w-[70px] rounded-full cursor-pointer" src="https://csencorsi.it/wp-content/uploads/2023/04/logo_150.png"></div>
           <div class="my-auto">
              <div class="font-semibold text-xl text-white">Albo Tecnici CSEN</div>
              <div class="font-medium text-md text-csenBlue-200">Centro Nazionale di Formazione (patentini / tesserini cartacei blu)</div>
           </div>
        </div>
        <!-- TOGGLE DARK MODE / LIGHT MODE -->
        <div class="text-white flex justify-end gap-2 my-auto">
            <!-- FAQ -->
            <div id="faq-btn" @click="redirectToFAQ" title="Vai alle F.A.Q."
               class="inline-flex group px-4 py-2 rounded-full bg-csenBlue-900/50 dark:bg-csenBlue-800/50 hover:bg-csenOrange-500 dark:hover:bg-csenOrange-500 transition cursor-pointer">
                  <ChatIcon></ChatIcon>
                  <span class="my-auto text-xs ml-2 text-csenBlue-200 group-hover:text-white">Hai dei dubbi o problemi?</span>
            </div>             
           <!-- Mostra Guida -->
           <div id="mostra-guida" v-if="loggedAs && loggedAs.ruolo == 'admin'" title="Mostra guida" @click="$emit('avvia-guida')" 
              class="inline-flex group px-3 rounded-full bg-csenBlue-900/50 dark:bg-csenBlue-800/50 hover:bg-csenOrange-500 dark:hover:bg-csenOrange-500 transition cursor-pointer">
              <v-icon color="white" class="my-auto mr-2" size="21">mdi-help-circle-outline</v-icon>
              <span class="my-auto text-xs text-csenBlue-200 group-hover:text-white pr-1">Mostra Guida</span>
           </div>
           <div
              :title="darkMode ? 'Passa alla Light Mode' : 'Passa alla Dark Mode'"
              @click="toggleDarkMode()"
              class="bg-csenBlue-900 dark:bg-csenBlue-800 text-csenBlue-100 inline-flex justify-center content-center px-auto cursor-pointer rounded-full hover:bg-csenOrange-500 dark:hover:bg-csenOrange-500 hover:text-white transition w-9 h-9"
              >
              <!-- Cambia l'icona basata sullo stato di darkMode -->
              <SunIcon v-if="darkMode" class="my-auto" />
              <MoonIcon v-else class="my-auto" />
           </div>
        </div>
     </div>
     <!-- FINE INTESTAZIONE DESKTOP -->
     <!-- MENU CHIPS (SOLO ADMIN SOLO DESKTOP) -->
     <div class="flex bg-transparent">
        <div v-if="loggedAs.ruolo=='admin'">
           <v-chip
              v-for="(item, index) in menuItems"
              :id="item.id"
              :key="index"
              :to="{ name: item.routeName }"
              class="mr-2 px-3 mt-6"
              :class="[item.routeName === $route.name ? '!bg-csenOrange-700 dark:!bg-csenOrange-700' : '!bg-csenBlue-900 dark:!bg-csenBlue-800', 'text-white']"
              text-color="white"
              clickable
              >
              <component class="mr-2" :is="item.icon" />
              {{ item.text }}
           </v-chip>
        </div>
     </div>
  </div>
</template>
<script>
  import HamburgerIcon from '../components/icons/HamburgerIcon.vue';
  import CloseIcon from '../components/icons/CloseIcon.vue';
  import ContattiIcon from '../components/icons/ContattiIcon.vue';
  import PhoneIcon from '../components/icons/PhoneIcon.vue';
  import InfoIcon from '../components/icons/InfoIcon.vue';
  import UserSearchIcon from '../components/icons/UserSearchIcon.vue';
  import IdCardIcon from '../components/icons/IdCardIcon.vue';
  import GraduationIcon from '../components/icons/GraduationIcon.vue';
  import StarIcon from '../components/icons/StarIcon.vue';
  import MailIcon from '../components/icons/MailIcon.vue';
  import SendIcon from '../components/icons/SendIcon.vue';
  import RedoIcon from '../components/icons/RedoIcon.vue';
  import InboxIcon from '../components/icons/InboxIcon.vue';
  import DrawIcon from '../components/icons/DrawIcon.vue';
  import SunIcon from '../components/icons/SunIcon.vue';
  import MoonIcon from '../components/icons/MoonIcon.vue';
  
  import mixin from '../mixin';
  import store from '../store';
  
  export default {
    name: 'MenuTecnici',
    props: {
      // darkMode: {
      //   type: Boolean,
      //   default: false,
      // },
    },
    components: {
      HamburgerIcon,
      CloseIcon,
      MoonIcon,
      SunIcon,
      ContattiIcon,
      PhoneIcon,
      DrawIcon,
      InboxIcon,
      GraduationIcon,
      InfoIcon,
      RedoIcon,
      StarIcon,
      UserSearchIcon,
      IdCardIcon,
      MailIcon,
      SendIcon,
    },
    mixins: [mixin],
    data() {
      return {
        drawer: false,
        menuItems: [
          { text: 'Tecnici', icon: 'ContattiIcon', routeName: 'tecnici', id: 'menu-tecnici-tab' },
          { text: 'Corsi', icon: 'GraduationIcon', routeName: 'corsi', id: 'menu-corsi-tab' },
          { text: 'Referenti', icon: 'StarIcon', routeName: 'referenti', id: 'menu-referenti-tab' },
          { text: 'Modelli E-mail', icon: 'InboxIcon', routeName: 'modelliemail', id: 'menu-modelli-email-tab' },
          { text: 'Circolari Automatiche', icon: 'RedoIcon', routeName: 'circolariautomatiche', id: 'menu-circolari-automatiche-tab' },
          { text: 'Circolari Inviate', icon: 'SendIcon', routeName: 'circolari', id: 'menu-circolari-inviate-tab' },
        ],
      };
    },
    methods: {
      toggleDarkMode() {
         store.commit('toggleDarkMode');
      },
    },
    computed: {
      isDesktop() {
        return window.innerWidth >= 768; // Breakpoint per desktop
      },
    },
  };
</script>
